export const GdprExcludedContries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'UK', 'IS', 'LI', 'NO', 'CH'];
export const isGdprCountry = country => {
  return GdprExcludedContries.includes(country.toUpperCase());
};